function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import React, { useState, useEffect } from 'react';
import { EntityCard } from '@finect/tabular-components/EntityCard';
import { Mention, MentionNoLink } from '../commons';
import { getEntity } from './actions';
export var EntityMention = function EntityMention(props) {
  var user = props.user,
    children = props.children;
  var id = user.id,
    subtype = user.subtype,
    alias = user.alias,
    url = user.url,
    web = user.web,
    link = user.link;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    profileInfo = _useState2[0],
    setProfileInfo = _useState2[1];
  var getInfo = function getInfo() {
    var promises = [];
    promises.push(getEntity('profile', id));
    var getEntityInfo = Promise.all(promises.map(function (promise) {
      return promise.catch(function () {
        return null;
      });
    }));
    getEntityInfo.then(function (results) {
      var _results = _slicedToArray(results, 1),
        entityData = _results[0];
      if (!entityData) return;
      setProfileInfo(entityData);
    });
  };
  useEffect(function () {
    getInfo();
  }, []);
  var userLink = url || web || link;
  var baseURL = "https://".concat(process.env.FINECT_BASEURL || 'www.finect.com');
  var mentionLink = userLink ? "".concat(baseURL).concat(userLink) : '';
  var hasProfile = profileInfo && profileInfo.subtype === 'user' ? profileInfo.features.includes('profile') : profileInfo && profileInfo.subtype === 'company' ? profileInfo.features.blog : false;
  return React.createElement(EntityCard, {
    type: "profile",
    entity: {
      id: id,
      type: subtype,
      name: alias,
      alias: alias
    }
  }, hasProfile ? React.createElement(Mention, {
    href: mentionLink
  }, children) : React.createElement(MentionNoLink, null, children));
};